import { Routes, Route, Navigate } from "react-router-dom";

import AuthProvider from "../context/AuthProvider";
// import PublicProvider from "./PublicProvider";
import PrivateProvider from "./PrivateProvider";
// import LoginPage from "../pages/ingreso/LoginPage";
import InicioPage from "../pages/Inicio/InicioPage";
import ListaEventos from "../pages/eventos/ListaEventos";
import Reportes from "../pages/reportes/Reportes";
import ListaUsuarios from "../pages/usuarios/ListaUsuarios";
import ListaProtocolos from "../pages/protocolos/ListaProtocolos";
import TablaUbicaciones from "../pages/locations/TablaUbicaciones";
import RecordatoriosPage from "../pages/recordatorios/RecordatoriosPage";

export default function index({ logoutLocalFuntion, logoutglobalFuntion }) {
  return (
    <AuthProvider>
      <Routes>
        {/* <Route path="/auth" element={<PublicProvider />}>
            <Route index element={<LoginPage />} />
          </Route> */}

        {/* Rutas privadas */}
        <Route
          path="/"
          element={
            <PrivateProvider
              logoutLocalFuntion={logoutLocalFuntion}
              logoutglobalFuntion={logoutglobalFuntion}
            />
          }
        >
          <Route path="" element={<InicioPage />} />
          <Route path="eventos" element={<ListaEventos />} />
          <Route path="protocolos" element={<ListaProtocolos />} />
          <Route path="dashboards" element={<Reportes />} />
          <Route path="usuarios" element={<ListaUsuarios />} />
          <Route path="ubicaciones" element={<TablaUbicaciones />} />
          <Route path="recordatorios" element={<RecordatoriosPage />} />
        </Route>

        {/* Redirección global para rutas no encontradas */}
        <Route path="*" element={<Navigate to="/inicio" replace />} />
      </Routes>
    </AuthProvider>
  );
}
